import { Fragment } from "react";
import { Alert } from "reactstrap";

function EvaLuateFormAlert({ isFilledObjectArray, EditGroup, countSumWeight, submitError, setSubmitError }) {
  const warnings = [];

//   if (!isFilledObjectArray(EditGroup)) warnings.push("กรุณากรอกข้อมูลให้ครบถ้วน");
//   if (countSumWeight !== null && Number(countSumWeight) !== 100 && Number(countSumWeight) !== 0) {
//     warnings.push("กรุณากรอกน้ำหนักร้อยละ (ข) ให้ผลรวมเท่ากับ 100");
//   }
  if (submitError) warnings.push(submitError);

  if (warnings.length === 0) return null;

  return (
    <Alert
      color="danger"
      className="text-center mt-2"
      toggle={() => setSubmitError(null)}
    >
      {warnings.map((v, i) => (
        <Fragment key={i}>
          <i className="fa-solid fa-triangle-exclamation me-3 fs-3" />
          {v}
          <br />
        </Fragment>
      ))}
    </Alert>
  );
}

export default EvaLuateFormAlert;